export const CREATE_INQUIRY = '/createinquiry'
export const DUEOUT = '/createdueout'
export const DUEOUTS = '/dueouts'
export const INQUIRIES = '/inquiries'
export const MY_INQUIRIES = '/myinquiries-dueouts'
export const ROUTE_TYPE = '/'
export const PROFILE = '/profile'
export const RHYBUS_ACCESS_TOKEN='rhybustoken'
export const APP_NAME='MPF-Dev'
export const CLIENT_CODE='clientcode'

export const PAGE_TITLE = {
    ACCESS_DENIED: 'Access Denied',
    ANNOUNCEMENTS: 'Announcements',
    ARCHIVED_INQUIRIES: 'Archived Inquiries',
    CALENDAR: 'Calendar',
    CANCELED: 'CANCELED',
    CLOSED: 'CLOSED',
    COMPLETED_INQUIRIES: 'Completed Inquiries',
    CREATE_DUEOUT: 'Create Dueout',
    CREATE_INQUIRY: 'Create Inquiry',
    DETAIL_VIEW: 'Detail View',
    DUEOUT_DETAIL_VIEW: 'Dueout Detail View',
    DUEOUTS: 'Due Outs',
    GENERATE: 'Generate', //may not be needed
    HOME: 'Home',
    INQUIRIES: 'Inquiries',
    KNOWLEDGEBASE: 'Knowledge Base',
    MY_INQUIRIES: 'My Inquiries',
    PII: 'PII',
    POINTS_OF_CONTACTS: 'Points of Contacts',
    POLICY_MEMOS_AND_GUIDELINES: 'Policy Memos & Guidelines',
    PROFILE: 'Profile',
    QA: 'Q&A',
    QUICK_LINKS: 'Quick Links',
    RELEASE_NOTES: 'Release Notes',
    SETTINGS: 'Settings',
    SITE_FEEDBACK: 'Site Feedback',
}